/**
 * A D-shaped section has vertical walls, so its width at SPL is its width.
 * The shared solvers read `widthspl` (horseshoe's battered-wall width), which
 * the D-shape form never asks for; a stored value must not stand in for W.
 */
export function withDshapeSection(dim) {
  return { ...dim, widthspl: dim.width };
}
